import apiClient from "./client";
import type { GetRolesParams, RolesListResponse } from "../types/role";

export const getRoles = async (
  params: GetRolesParams = {}
): Promise<RolesListResponse> => {
  const { data } = await apiClient.get<RolesListResponse>("/roles", {
    params,
  });
  return data;
};
